<template>
  <b-card no-body>
    <el-table
      class="table-responsive table"
      header-row-class-name="thead-light"
      :data="data"
    >
      <el-table-column sortable label="Check" prop="name">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <base-checkbox v-model="row.check" @input="checkedControl(row)" />
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="Nombre y Apellidos"
        min-width="150px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.catequista
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  props: ["data", "multiple"],
  mounted() {},
  methods: {
    checkedControl(catequistaSelec) {
      if (!this.multiple) {
        this.data = this.data.map((element) => {
          if (catequistaSelec.id != element.id) {
            element.check = false;
          }
          return element;
        });
      }
      this.$emit('catequistaSeleccionado', this.data);
    },
  },
};
</script>
<style scoped>
.separador {
  border-left: 1px solid rgb(2, 2, 2);
  height: auto;
}
</style>
